import { MarkedOptions } from 'marked';

export const CURRENCY = 'CURRENCY';
export const CURRENCY_ISO = 'CURRENCY_ISO';

export const __MARKED_OPTIONS: MarkedOptions = {
	async: false,
	breaks: true,
};
